/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import tmplSelectionItemView from './SelectionItemView.hbs';

import './SelectionItemView.css';

const SelectionItemView = View.extend({
  template: tmplSelectionItemView,

  className: 'selection-itemview col-lg-3 col-md-6 col-sm-12 mb-3',

  ui: {
    checkbox: '.form-check-input',
    label: '.form-check-label'
  },

  regions: {},

  events: {
    'change @ui.checkbox': 'onChangeCheckbox'
  },

  initialize() {
    if (!this.model.get('isChecked')) {
      this.model.set('isChecked', false);
    }
  },

  onRender() {},

  onChangeCheckbox() {
    const isChecked = !this.model.get('isChecked');
    this.model.set('isChecked', isChecked);
    this.triggerMethod('checkbox:changed', this.model);
  },

  setChecked(isChecked) {
    this.model.set('isChecked', isChecked);
    this.ui.checkbox.prop('checked', isChecked);
  },

  isChecked() {
    return !!this.model.get('isChecked');
  },

  setDisabled(isDisabled) {
    this.model.set('isDisabled', isDisabled);
    this.ui.checkbox.prop('disabled', isDisabled);
    this.ui.label.addClass('disabled-label');
  }
});

export default SelectionItemView;
